import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { exportToCSV, exportToPDF } from '../../utils/exportUtils';

const { FiDownload, FiFileText, FiCheck, FiChevronDown } = FiIcons;

const ExportBar = ({ reportTitle, data, columns, summaryStats, rowCount }) => {
  const [open, setOpen] = useState(false);
  const [exported, setExported] = useState(null);

  const handleExport = (type) => {
    if (type === 'csv') exportToCSV(data, reportTitle.replace(/\s+/g, '_'), columns);
    if (type === 'pdf') exportToPDF(reportTitle, data, columns, summaryStats);
    setExported(type);
    setOpen(false);
    setTimeout(() => setExported(null), 2000);
  };

  return (
    <div className="flex items-center justify-between bg-white rounded-xl border border-slate-200 shadow-sm px-5 py-3">
      <div className="text-sm text-slate-500">
        <span className="font-semibold text-slate-700">{rowCount}</span> records in this report
      </div>
      <div className="relative">
        <button onClick={() => setOpen(o => !o)}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold transition-colors shadow-sm ${exported ? 'bg-emerald-600 text-white' : 'bg-blue-600 hover:bg-blue-700 text-white'}`}>
          <SafeIcon icon={exported ? FiCheck : FiDownload} />
          {exported ? `Exported as ${exported.toUpperCase()}!` : 'Export Report'}
          {!exported && <SafeIcon icon={FiChevronDown} className="text-xs opacity-70" />}
        </button>

        <AnimatePresence>
          {open && (
            <motion.div initial={{ opacity: 0, y: 6, scale: 0.97 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 4 }}
              className="absolute right-0 top-full mt-2 w-44 bg-white rounded-xl border border-slate-200 shadow-lg z-20 overflow-hidden">
              <button onClick={() => handleExport('csv')}
                className="w-full flex items-center gap-3 px-4 py-3 text-sm text-slate-700 hover:bg-slate-50 transition-colors border-b border-slate-100">
                <SafeIcon icon={FiFileText} className="text-emerald-500" />
                Export as CSV
              </button>
              <button onClick={() => handleExport('pdf')}
                className="w-full flex items-center gap-3 px-4 py-3 text-sm text-slate-700 hover:bg-slate-50 transition-colors">
                <SafeIcon icon={FiFileText} className="text-red-500" />
                Export as PDF
              </button>
            </motion.div>
          )}
        </AnimatePresence>

        {open && <div className="fixed inset-0 z-10" onClick={() => setOpen(false)} />}
      </div>
    </div>
  );
};

export default ExportBar;